import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarMenuService {
  private isSidebarOpenSignal = signal<boolean>(false);
  private isNavBtnSelectedSignal = signal<boolean>(false);

  private readonly LOCAL_STORAGE_KEY = 'sidebarOpen';

  isSidebarOpen(): boolean {
    return this.isSidebarOpenSignal();
  }

  isNavBtnSelected(): boolean {
    return this.isNavBtnSelectedSignal();
  }

  loadFromLocalStorage(): void {
    const saved = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (saved) {
      this.isNavBtnSelectedSignal.set(saved === 'true');
    }
    this.setSidebarOpen(this.isNavBtnSelectedSignal());
  }

  setSidebarOpen(isSidebarOpen: boolean): void {
    this.isSidebarOpenSignal.set(isSidebarOpen);
  }

  setIsNavBtnSelected(isNavBtnSelected: boolean): void {
    this.isNavBtnSelectedSignal.set(isNavBtnSelected);
    localStorage.setItem(this.LOCAL_STORAGE_KEY, isNavBtnSelected.toString());
  }
}
